<div style="height: 8px" [ngClass]="getHeaderClass()" class="col-12"></div>
<h2 style="cursor: grabbing" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="mb-0" mat-dialog-title>
  {{ data.title }}
</h2>

<mat-dialog-content class="mat-typography pt-0">
  <div style="margin-top: 5%">
    <mat-divider></mat-divider>
    <div class="div-contenu">
      <div>
        <mat-icon [ngClass]="getIconClass()">{{ getIcon() }}</mat-icon>
      </div>
      <div>
        <div>
          {{ data.content }}
        </div>
        @if (data.content2 != '' && data.content2 != null) {
        <div>
          {{ data.content2 }}
        </div>
        }
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-flat-button [color]="getButtonColor()" [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
  @if (data.showCancelButton) {
  <button mat-flat-button [color]="getButtonColor()" [mat-dialog-close]="false" cdkFocusInitial>
    Annuler
  </button>
  }
</mat-dialog-actions>